const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_627",
  "data-name": "Rectangle 627",
  width: 74.105,
  height: 74.091,
  fill: "#e3021c",
  stroke: "#e3021c",
  strokeWidth: 0.5
})));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_505",
  "data-name": "Group 505",
  clipPath: "url(#clip-path)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_173",
  "data-name": "Path 173",
  d: "M74.047,50.586,60.153,4.849a1.157,1.157,0,0,0-1.331-.81L45.853,6.412A9.265,9.265,0,0,0,27.79,9.77L14.821,12.144a1.126,1.126,0,0,0-.868.81L.058,58.691A.733.733,0,0,0,0,59.039a15.053,15.053,0,1,0,30.105,0,.733.733,0,0,0-.058-.348L16.558,14.228l11.694-2.142a9.264,9.264,0,0,0,8.8,6.427,8.751,8.751,0,0,0,1.679-.173,9.32,9.32,0,0,0,7.584-9.611L57.432,6.644,44.116,50.586a.425.425,0,0,0-.116.348,15.053,15.053,0,1,0,30.105,0,.733.733,0,0,0-.058-.348M15.053,71.775A12.724,12.724,0,0,1,2.374,60.2H27.731A12.724,12.724,0,0,1,15.053,71.775M9.958,57.881a5.228,5.228,0,0,1,10.189,0Zm17.426,0H22.463a7.5,7.5,0,0,0-14.82,0H2.721L15.053,17.3Zm10.943-41.8A6.994,6.994,0,0,1,31.321,5.254,7.078,7.078,0,0,1,35.779,2.36c.464,0,.868-.058,1.274-.058A6.948,6.948,0,0,1,38.327,16.08M59.053,9.191,71.384,49.775H66.927L59.921,42.77a1.12,1.12,0,0,0-1.621,0l-7.122,7.005H46.722Zm4.574,40.585H54.479L59.053,45.2ZM59.053,63.67A12.724,12.724,0,0,1,46.374,52.091H71.732A12.724,12.724,0,0,1,59.053,63.67",
  transform: "translate(0 0)",
  fill: "#e3021c",
  stroke: "#e3021c",
  strokeWidth: 0.5
}));
function SvgIconScale(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_506",
    "data-name": "Group 506",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 74.105,
    height: 74.091,
    viewBox: "0 0 74.105 74.091",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconScale);
export default __webpack_public_path__ + "static/media/icon-scale.96ccbcbc.svg";
export { ForwardRef as ReactComponent };